import { Box, Card, CardContent, Typography, useTheme } from "@mui/material";
import type { LucideIcon } from "lucide-react";
import type { FC, ReactNode } from "react";

export const DetailField: FC<{
  icon: LucideIcon;
  label: string;
  value?: string | null;
  children?: ReactNode;
  flex?: number;
}> = ({ icon: Icon, label, value, children, flex }) => {
  const { colors, customSpacing, radius, customFontWeight } = useTheme();

  return (
    <Card
      sx={{
        flex,
        boxShadow: "none",
        border: `1px solid ${colors.border.primary}`,
        borderRadius: radius.xl,
        minHeight: 56,
        display: "flex",
        flexDirection: "column",
        boxSizing: "border-box",
      }}
    >
      <CardContent
        sx={{
          display: "flex",
          alignItems: "center",
          padding: customSpacing.xl,
          "&:last-child": { paddingBottom: customSpacing.xl },
          flex: 1,
          minHeight: 0,
        }}
      >
        <Icon size={16} color={colors.text.secondary} />
        <Typography
          variant="body2"
          color={colors.text.secondary}
          paddingLeft={customSpacing.sm}
        >
          {label}
        </Typography>
        <Box sx={{ ml: "auto" }}>
          {children || (
            <Typography variant="body2" fontWeight={customFontWeight.medium}>
              {value}
            </Typography>
          )}
        </Box>
      </CardContent>
    </Card>
  );
};
